module.exports = __webpack_public_path__ + "img/noises-28.2e5c338b.jpg";